/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsDocContent
 */
export interface IdentityMelcoModelsDocContent {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsDocContent
     */
    tags?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsDocContent
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsDocContent
     */
    type?: string | null;
}

export function IdentityMelcoModelsDocContentFromJSON(json: any): IdentityMelcoModelsDocContent {
    return IdentityMelcoModelsDocContentFromJSONTyped(json, false);
}

export function IdentityMelcoModelsDocContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsDocContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function IdentityMelcoModelsDocContentToJSON(value?: IdentityMelcoModelsDocContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tags': value.tags,
        'content': value.content,
        'type': value.type,
    };
}


